import { IconSparkles } from '@posthog/icons';
import { CalloutBox } from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  IconSparkles,
  CalloutBox,
  React
};